import { render, staticRenderFns } from "./InformeMain.vue?vue&type=template&id=eea890da&scoped=true&"
import script from "./InformeMain.vue?vue&type=script&lang=js&"
export * from "./InformeMain.vue?vue&type=script&lang=js&"
import style0 from "./InformeMain.vue?vue&type=style&index=0&id=eea890da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea890da",
  null
  
)

export default component.exports